const IconButton = ({ icon, className, ...props }) => {
  return (
    <button
      type="button"
      className={["icon-btn", className].join(" ")}
      {...props}
    >
      {icon}
    </button>
  );
};

export default IconButton;
